import { createAsyncActionType } from './index';

export const SEARCH_MANDATORY_TRAINING_LIST_GET = createAsyncActionType('search', 'SEARCH_MANDATORY_TRAINING_LIST_GET');
export const SEARCH_OPTIONAL_COURSES_LIST_GET = createAsyncActionType('search', 'SEARCH_OPTIONAL_COURSES_LIST_GET');
export const SEARCH_SET_FAVOURITE = createAsyncActionType('search', 'SEARCH_SET_FAVOURITE');
export const SEARCH_WORD_SET = '@@search/SEARCH_WORD_SET';